import ArchiveCard from './ArchiveCard'

export default ArchiveCard